import {DefaultChildren} from '#/utils/utils';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

export const LoadingLands: FunctionComponent<DefaultChildren> = () => {
  const {t} = useTranslation('translation');

  return (
    <span className='text-xl md:text-2xl text-white font-semibold mb-1 uppercase animate-pulse'>
      {t('statuses.loadingDots')}
    </span>
  );
};
